<template>
  <v-container fluid>
    <v-flex xs12>
      <v-card  style="margin-top: -10px;">
        <v-card-title>
          <v-text-field append-icon="search" label="Quick Search" single-line hide-details v-model="search" clearable style="width: 300px; margin-top: -20px; margin-left: 20px;"></v-text-field>
        <v-spacer></v-spacer>
        <v-select v-if="$route.path == '/orders' && orders.length > 0" class="mt-3 mb-6 select-box" v-bind:items="currencies" label="Валюта" v-model="currency">
          <template slot="selection" slot-scope="currencies">
            {{ currencies.item }} 
          </template>
          <template slot="item" slot-scope="currencies">
            {{ currencies.item }} 
          </template>
        </v-select>

        <table v-if="$route.path == '/orders' && resume[currency]">
          <tr>
            <td class="info-label info-sell">Sell:</td>
            <td class="info-sum info-sell">{{ formSum(resume[currency].sell.fiat) }}</td><td>{{ currency }}</td>
            <td class="info-sum" style="text-align: right;">({{ resume[currency].sell.count }})</td><td></td>
          </tr>
          <tr>
            <td class="info-label" :style="'color: ' + (dark ? '#00FF00;' : 'green;')">Buy:</td>
            <td class="info-sum" :style="'color: ' + (dark ? '#00FF00;' : 'green;')">{{ formSum(resume[currency].buy.fiat) }}</td><td>{{ currency }}</td>
            <td class="info-sum" style="text-align: right;">({{ resume[currency].buy.count }})</td><td></td>
          </tr>
        </table>

        &nbsp;&nbsp;&nbsp;&nbsp;
        <table v-if="$route.path == '/orders' && resume[currency]">
          <tr>
            <td class="info-label info-sell"></td>
            <td class="info-sum info-sell">{{ formSum(resume[currency].sell.usdt, 100) }}</td><td>₮</td>
          </tr>
          <tr>
            <td class="info-label info-buy"></td>
            <td class="info-sum" :style="'color: ' + (dark ? '#00FF00;' : 'green;')">{{ formSum(resume[currency].buy.usdt, 100) }}</td><td>₮</td>
          </tr>
        </table>

        &nbsp;&nbsp;&nbsp;&nbsp;
        <table v-if="$route.path == '/orders' && resume[currency]">
          <tr>
            <td class="info-label">Rate:</td>
            <td class="info-sum info-sell">{{ Math.floor(resume[currency].sell.rate * 100) / 100 }}</td><td>{{ currency }}/₮</td>
          </tr>
          <tr>
            <td class="info-label info-buy"></td>
            <td class="info-sum" :style="'color: ' + (dark ? '#00FF00;' : 'green;')">{{ Math.floor(resume[currency].buy.rate * 100) / 100 }}</td><td>{{ currency }}/₮</td>
          </tr>
        </table>

        <v-spacer></v-spacer>
        <v-btn class="brown lighten-1" fab small dark @click.native="refreshFilters()">
          <v-icon>refresh</v-icon>
        </v-btn>
        </v-card-title>
          <v-data-table
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            class="elevation-1" :headers="headers" :items="orders" :search="search" :pagination.sync="pagination" :rows-per-page-items="[100, 200, 500]" sortable>
              <template slot="headers" slot-scope="props">
                <tr>
                  <th :class="['column', 'subheading', 'text-xs-center']">Аккаунт</th>
                  <th v-for="(header, index) in props.headers" :key="header.text" :class="['column', 'subheading', 'text-xs-center']">
                    {{ header.text }}
                  </th>
                  <th>                
                  </th>
                </tr>
            </template>
            <template class="body-2 info-table" slot="items" slot-scope="props">
              <td class="info-table">{{ props.item.userName }}</td>
              <td class="info-table" width="80"><a target=_blank :href="'https://www.bybit.com/en/fiat/trade/otc/orderList/' + props.item.id ">{{ props.item.id }}</a><br>{{ timestampToDate2(props.item.createDate) }}</td>
              <td class="info-table" width="60" style="white-space: nowrap;">{{ props.item.targetNickName }}</td>
              <td class="info-table">{{ props.item.targetUserId }}</td>
              <td class="info-table" :style="'color: ' + (props.item.side==0 ? (dark ? '#00FF00;' : 'green;') : 'red;')">{{ props.item.notifyTokenQuantity }}<br></td>
              <td class="info-table" :style="'color: ' + (props.item.side==0 ? (dark ? '#00FF00;' : 'green;') : 'red;')"><b>{{ props.item.amount }}</b></td>
              <td class="info-table" :style="'color: ' + (props.item.side==0 ? (dark ? '#00FF00;' : 'green;') : 'red;')">{{ props.item.price }}</td>
              <td class="info-table" :style="'color: ' + (props.item.side==0 ? (dark ? '#00FF00;' : 'green;') : 'red;')">{{ props.item.currencyId }}</td>
              <td class="info-table">{{ props.item.status==50 ? '✅' : (props.item.status==40 ? '❌' : '⌛') }}</td>
            </template>
            <template slot="no-data">
             <span >
                <p class="pt-2 blue--text subheading">   <v-icon medium class="blue--text" >info</v-icon>Sorry, nothing to display here :(</p>
              </span>
            </template>
          </v-data-table>
  </v-card>
  </v-flex>
  </v-container>
</template>
<script>
/* globals Store */
/* globals chrome */
import { mapState } from "vuex";
export default {
  name: "orders",
  props: ['dark'],
  data() {
    return {
      query: '',
      sortBy: 'createDate',
      sortDesc: true,
      search: "",
      sync: false,
      accounts: [],
      userNames: {},
      currency: 'RUB',
      headers: [
        { text: 'Id ордера', value: 'id' },
        { text: 'Контрагент', left: true, value: 'targetNickName' },
        { text: 'UID', left: true, value: 'targetUserId' },
        { text: 'Сумма usdt', value: 'notifyTokenQuantity' },
        { text: 'Сумма фиат', value: 'amount' },
        { text: 'Цена', value: 'price' },
        { text: 'Валюта', value: 'currencyId' },
        { text: 'Статус', value: 'status' },
      ],
      pagination: { sortBy: 'createDate', descending: true, rowsPerPage: 100 }
    };
  },
  methods: {
    async fillUserName(userId) {
      if (this.userNames[userId]) return;
      this.userNames[userId] = userId;
      const result = await chrome.storage.local.get(["use_proxy", "bankpdf_token"]);
      const token = result.bankpdf_token;
//      chrome.runtime.sendMessage({type: 'GET_BYBIT_NICKNAME', userId: userId, token: token}, (response) => {
//        if (!response.result.nickname) return;
//        this.userNames[userId] = response.result.nickname;
//        chrome.storage.local.get('accounts_store').then((result) => {
//          let accountsStore = result.accounts_store || {};
//          accountsStore[userId] = response.result.nickname;
//          chrome.storage.local.set({ accounts_store: accountsStore });
//        });
//      });
    },
    refreshFilters() {
      this.query = "from=" + this.from + "%20" + this.fromTime + "&until=" + this.until + "%20" + this.untilTime + "&account=" + (this.account || '');
      this.$Progress.start();

      Store.dispatch("orders/searchOrders", this.query, this.pagination);
    },
    formSum (s, num = 1) {
      const first = Math.floor(s);
      const second = Math.floor((Math.floor(s * num) / num - first) * num);
      let sum = first.toString().split('').reverse().map((el, index) => index % 3 !== 2 ? el : ` ${el}`).reverse().join('');
      return second > 0 ? String(sum) + '.' + String(second) : sum;
    },
    timestampToDate2(timestamp) {
      const date = new Date(Number(timestamp));
      const options = {
          year: 'numeric',
          month: 'numeric',
          day: 'numeric',
          hour: 'numeric',
          minute: 'numeric',
          timeZone: 'UTC',
          hour12: false
      };
      const formattedDate = date.toLocaleString('ru-RU', options);
      return formattedDate;
    }
  },
  computed: {
    ...mapState("orders", {
      orders: "items",
      currencies: "currencies",
      resume: "resume",
      qsitems: "qsitems",
//      pagination: "pagination",
      loading: "loading",
      snackbar: "snackbar",
      notice: "notice"
    }),
    ...mapState("filters", {
      from: "from",
      until: "until",
      fromTime: "fromTime",
      untilTime: "untilTime",
      account: "account",
    }),
  },
  watch: {
      from() {
        this.refreshFilters();
      },
      until() {
        this.refreshFilters();
      },
      fromTime() {
        this.refreshFilters();
      },
      untilTime() {
        this.refreshFilters();
      },
      orders() {
        this.$Progress.finish();
      },
      account() {
        this.refreshFilters();
      },
      accounts() {
        Store.dispatch("filters/setAccounts", this.accounts);
      },
  },
  created () {
//    const bindThis = this;
//      chrome.storage.local.get(["sync_status"]).then((result) => {
//        if (typeof (result.sync_status) !== 'undefined' && result.sync_status === true) this.sync = true;
//      });
    this.refreshFilters();
  },
};
</script>
<style>
  body {
    text-align:center;
    width:100%;
  }
</style>
<style scoped>
  .right-input >>> input {
    width: 110px;
  }
  .select-box {
    max-width: 110px;
  }
  .info-table {
    font-size: 16px;
  }
  .info-label {
    vertical-align: text-top; 
    font-size: 10px;
  }
  .info-sum {
    font-size: 18px;
    text-align: right;
  }
  .info-sell {
    color: red;
  }
  .info-buy {
    color: green;
  }
</style>



// WEBPACK FOOTER //
// OrderList.vue?433b0bd6